import angular from 'angular';
import {StavkaNalogaFormComponent} from './stavkaNalogaForm.component.js';
import {OdabirPozicijaFormComponent} from './odabirPozicijaForm.component.js';
import {PozicijeComponent} from './pozicije.component.js';
import {KvadrantComponent} from './kvadrant.component.js';
import {protetskiPozicije} from './protetskiPozicije.directive.js';
import {VrstaRadaComponent} from './vrstaRada.component.js';
import {MaterijalComponent} from './materijal.component.js';

const stavkaNaloga = angular.module('stavkaNaloga', []);


stavkaNaloga.component('stavkaNalogaForm', StavkaNalogaFormComponent);
stavkaNaloga.component('odabirPozicijaForm', OdabirPozicijaFormComponent);
stavkaNaloga.component('pozicije', PozicijeComponent);
stavkaNaloga.component('kvadrant', KvadrantComponent);
stavkaNaloga.component('vrstaRada', VrstaRadaComponent);
stavkaNaloga.component('materijal', MaterijalComponent);

stavkaNaloga.directive('protetskiPozicije', protetskiPozicije);

export {stavkaNaloga};



// WEBPACK FOOTER //
// ./app/components/stavkaNaloga/stavkaNaloga.js